var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mh-100 h-100" }, [
    _vm.currentJob.state === "processing"
      ? _c("div", { staticClass: "h-100 mh-100" }, [
          _c("div", { staticClass: "gallery-16 overflow-hidden" }, [
            _c(
              "div",
              {
                staticClass:
                  "gallery-row d-flex justify-content-center loading",
              },
              _vm._l(4, function (idx) {
                return _c(
                  "div",
                  { key: idx, staticClass: "image align-items-end" },
                  [_c("img", { attrs: { src: _vm.loadingImage } })]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "gallery-row d-flex justify-content-center loading",
              },
              _vm._l(4, function (idx) {
                return _c(
                  "div",
                  { key: idx, staticClass: "image align-items-center" },
                  [_c("img", { attrs: { src: _vm.loadingImage } })]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "gallery-row d-flex justify-content-center loading",
              },
              _vm._l(4, function (idx) {
                return _c(
                  "div",
                  { key: idx, staticClass: "image align-items-center" },
                  [_c("img", { attrs: { src: _vm.loadingImage } })]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "gallery-row d-flex justify-content-center loading",
              },
              _vm._l(4, function (idx) {
                return _c(
                  "div",
                  { key: idx, staticClass: "image align-items-start" },
                  [_c("img", { attrs: { src: _vm.loadingImage } })]
                )
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.currentJob.state === "completed"
      ? _c("div", { staticClass: "h-100 mh-100" }, [
          _c("div", { staticClass: "gallery-16 overflow-hidden" }, [
            _c(
              "div",
              { staticClass: "gallery-row d-flex justify-content-center" },
              [
                _c(
                  "div",
                  { staticClass: "image align-items-end" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 0 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob.base64_output_images[0],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        232953223
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image align-items-end" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 1 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob.base64_output_images[1],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4020609446
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image align-items-end" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 2 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob.base64_output_images[2],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3091564357
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image align-items-end" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 3 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob.base64_output_images[3],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2999077732
                      ),
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gallery-row d-flex justify-content-center" },
              [
                _c(
                  "div",
                  { staticClass: "image align-items-center" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 4 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob.base64_output_images[4],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2949555459
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image align-items-center" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 5 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob.base64_output_images[5],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2442244386
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image align-items-center" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 6 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob.base64_output_images[6],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1513199297
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image align-items-center" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 7 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob.base64_output_images[7],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1420712672
                      ),
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gallery-row d-flex justify-content-center" },
              [
                _c(
                  "div",
                  { staticClass: "image align-items-center" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 8 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob.base64_output_images[8],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3428942479
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image align-items-center" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 9 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob.base64_output_images[9],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2921631406
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image align-items-center" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 10 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob
                                      .base64_output_images[10],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        611865302
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image align-items-center" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 11 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob
                                      .base64_output_images[11],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3500233175
                      ),
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gallery-row d-flex justify-content-center" },
              [
                _c(
                  "div",
                  { staticClass: "image align-items-start" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 12 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob
                                      .base64_output_images[12],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1548117972
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image align-items-start" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 13 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob
                                      .base64_output_images[13],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        988980437
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image align-items-start" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 14 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob
                                      .base64_output_images[14],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2236608978
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image align-items-start" },
                  [
                    _c("router-link", {
                      attrs: {
                        to: {
                          name: "SelectedImageCanvas",
                          params: { uuid: _vm.id, selected_image: 15 },
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              href,
                              route,
                              navigate,
                              isActive,
                              isExactActive,
                            }) {
                              return [
                                _c("img", {
                                  staticClass: "result-img",
                                  attrs: {
                                    src: _vm.currentJob
                                      .base64_output_images[15],
                                  },
                                  on: { click: navigate },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        830009555
                      ),
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }